var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCardImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869141,
    width: 125.263,
    height: 125.263,
    rx: 62.6316,
    fill: "#FFF4E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13015_17700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 30,
    width: 65,
    height: 65
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 30.6328,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13015_17700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.166 86.6354L63.4993 35.9688L92.8327 86.6354H34.166ZM43.366 81.3021H83.6327L63.4993 46.6354L43.366 81.3021ZM63.4993 78.6354C64.2549 78.6354 64.8882 78.3799 65.3994 77.8688C65.9105 77.3576 66.166 76.7243 66.166 75.9688C66.166 75.2132 65.9105 74.5799 65.3994 74.0688C64.8882 73.5576 64.2549 73.3021 63.4993 73.3021C62.7438 73.3021 62.1105 73.5576 61.5993 74.0688C61.0882 74.5799 60.8327 75.2132 60.8327 75.9688C60.8327 76.7243 61.0882 77.3576 61.5993 77.8688C62.1105 78.3799 62.7438 78.6354 63.4993 78.6354ZM60.8327 70.6354H66.166V57.3021H60.8327V70.6354Z",
    fill: "#F9A932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCardImg);
export default __webpack_public_path__ + "static/media/delete-card-img.5351974219537900fe7303d544f71970.svg";
export { ForwardRef as ReactComponent };